import { render, staticRenderFns } from "./MyOrganizationIndex.vue?vue&type=template&id=33a69f23"
import script from "./MyOrganizationIndex.vue?vue&type=script&lang=js"
export * from "./MyOrganizationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports